const GameConfig = {
    DEBUG: {
        ON: false,
        PHYSICS: false,
        RAYCASTER: false,
        HIDE_PLAYER: false,
        NO_DECO: false
    },
    POST_PRO: {
        SAO: false,
        SSAO: {
            USE: false,
            USE_DESKTOP: true,
            KERNEL_RADIUS: 10,
            MIN_DISTANCE: 0.05,
            MAX_DISTANCE: 0.05,
        },
        BLOOM: {
            USE: true,
            /*
            STRENGTH: 0.25,
            RADIUS: 0.1,
            THRESHOLD: 0.15
            */
            STRENGTH: 0.125,
            RADIUS: 0.01,
            THRESHOLD: 0.65
        }
    },
    LIGHT: {
        AMBIENT: {
            COLOR: 0xFFFFFF,
            INTENSITY: 0.2,
        },
        DIRECTIONAL: {
            POSITION: {
                X: 0,
                Y: 1,
                Z: -1,
            },
            TARGET_POSITION: {
                X: 0,
                Y: 0,
                Z: 0,
            },
            COLOR: 0xF0F0F0,
            INTENSITY: 0.9,
        },
    },
    CAMERA: {
        NEAR: 3,
        FAR: 91,
        FOV: 75,
        DISTANCE: {
            X: 0,
            Y: 4,
            Z: 7.5
        }
    },
    FOG: {
        COLOR: 0xdddddd,
        NEAR: 30,
        FAR: 40
    },
    GENERAL: {
        START_SPEED: 5,
        SPEED_ACCELERATION: 0.1, // speed increase per second
        SPEED_CAP: 10,
        SLOW_MOTION_TIME_SCALE: 0.15,
        OBSTACLE_DEPTH: 0.5,
        SKILL_GATE_DEPTH: 5,
        PLAYER_BOUNDING_BOX_SCALE: 0.75,
        GROUND_Y: 0,
        GATE_SIGNS_START: 2,
        GATE_SIGN_INCREASE_TIME: 25,
        GATE_SIGN_MAX: 6
    },
    HIGHSCORE: {
        URL: "https://chriogames.com/highscore/foxRun/main",
        S: "0y21lka0du232i02a",
        SIZE: 3,
        ENTRIES: 99
    }
}
export default GameConfig;